//#region components
import { useCheckRelations } from "components/common";
import { useAdvisorPermissions } from "components/advisor";
import useDocumentPermissions from "../../usePermissions";
//#endregion

const useSharedDocumentPermissions = () => {
  const { getIsRevisor } = useCheckRelations();
  const { isAdvisor } = useAdvisorPermissions();
  const { hasDocumentPermissions } = useDocumentPermissions();

  const hasSharedDocumentViewPermissions = () => {
    return hasDocumentPermissions || isAdvisor || getIsRevisor();
  };

  const hasSharedDocumentCreatePermissions = () => isAdvisor;

  return {
    hasSharedDocumentViewPermissions,
    hasSharedDocumentCreatePermissions,
  };
};

export default useSharedDocumentPermissions;
